module.exports = __webpack_public_path__ + "img/tips6_bg.31c32a3d.jpg";